module.exports = "/assets/magnifier.svg";